import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export const ALL_SIZES = 'ALL_SIZES';

export type SizeTargetProperties = {
  product_id: string;
  selected_size: string;
};

type EventData = {
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  productId: string;
  selectedSize?: string;
};

class SizeInteractionEvent extends InteractionEvent<
  EventData,
  SizeTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'size';
  }

  protected getTargetProperties(): SizeTargetProperties {
    return {
      product_id: this.data.productId,
      selected_size: this.data.selectedSize || ALL_SIZES
    };
  }
}

export default SizeInteractionEvent;
